export const ClickablePhoneVariant = {
  LINK: 'link',
  ICON_BUTTON: 'iconButton',
};

export const CALL_TOOLTIP_PREFIX = 'Call';
